<div class="section-header">
  <div class="section-header__main">
    <div
      *ngIf="icon"
      class="section-header__icon"
    >
      <mat-icon>{{ icon }}</mat-icon>
    </div>

    <div class="section-header__content">
      <h3 class="section-header__title">
        {{ title }}
      </h3>

      <p
        *ngIf="description"
        class="section-header__description"
      >
        {{ description }}
      </p>
    </div>
  </div>

  <div class="section-header__actions">
    <ng-content></ng-content>
  </div>
</div>
